module.exports = __webpack_public_path__ + "7d4b746cb6d17664fde711fd290f9a85.svg";